// a coupon code can be in the url followed by /i/ or as a query param 'referral_code' the former takes precedence
// For reasons, this code needs to be outside of an async function or it will fail.
function getCouponOrReferralCode(pathname: string, search: Record<string, any>): string | null | undefined {
  let code: string | null | undefined;
  // /invite/E8ET3J
  const paths = pathname.split('/').map((s) => s.toLowerCase());

  if (paths.indexOf('i') !== -1) {
    code = pathname.split('/')[paths.indexOf('i') + 1];
  } else if (paths.indexOf('invite') !== -1) {
    code = pathname.split('/')[paths.indexOf('invite') + 1];
  } else {
    const { referral_code, invite_code } = search;
    code = referral_code || invite_code;
  }

  return code;
}

export default getCouponOrReferralCode;
